import axios from '../src/axios'
import { ENDPOINTS } from '../src/constants'

export type EmailDomainContext = 'signin' | 'signup'

export const EMAIL_DOMAIN_BLOCKED_CODE = 'EMAIL_DOMAIN_BLOCKED'
export const EMAIL_DOMAIN_BLOCKED_MESSAGE =
  "We currently don't support this email domain. Please use a different email address."

export interface ApiErrorResponse {
  status?: number
  data?: {
    code?: string
    message?: string
  }
}

export const getApiErrorResponse = (
  error: unknown
): ApiErrorResponse | undefined => {
  if (!error || typeof error !== 'object') return undefined
  return (error as { response?: ApiErrorResponse }).response
}

/**
 * Authoritative email-domain check via backend (active rules).
 * On network/API failure, allow through — auth endpoints enforce server-side.
 */
export const validateEmailDomain = async (
  email: string,
  context: EmailDomainContext
): Promise<{ isValid: boolean; errorMessage?: string }> => {
  try {
    await axios.post(ENDPOINTS.validateEmailDomain, {
      email,
      context,
    })
    return { isValid: true }
  } catch (error) {
    const response = getApiErrorResponse(error)
    if (
      response?.status === 400 ||
      response?.data?.code === EMAIL_DOMAIN_BLOCKED_CODE
    ) {
      return {
        isValid: false,
        errorMessage: response?.data?.message || EMAIL_DOMAIN_BLOCKED_MESSAGE,
      }
    }
    return { isValid: true }
  }
}

export const isEmailDomainBlockedError = (error: unknown): boolean => {
  const response = getApiErrorResponse(error)
  return (
    response?.status === 400 &&
    response?.data?.code === EMAIL_DOMAIN_BLOCKED_CODE
  )
}

export const getEmailDomainBlockedMessage = (error: unknown): string => {
  const response = getApiErrorResponse(error)
  return response?.data?.message || EMAIL_DOMAIN_BLOCKED_MESSAGE
}
